import React from "react";
import {authRoles} from "app/auth/index.js";

import i18next from "../../../i18n.js";

import en from "./i18n/en.js";
import fr from "./i18n/fr.js";

i18next.addResourceBundle("en", "profile", en);
i18next.addResourceBundle("fr", "profile", fr);

const ProfileConfig = {
  settings: {layout: {config: {}}},
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: "/profile/:username",
      exact: true,
      component: React.lazy(() => import("./Profile.js")),
    },
  ],
};

export default ProfileConfig;
